import './style/cate-index.less'
import $ from 'jquery'
import cateNav from './js/cate-nav'
import govCard from './js/gov-card'
import extendCate from './js/extend-cate'

/**
 * 首页左侧导航栏
 */
module.exports = {

    init: (config) => {

        // 首页网购大家评模块
        if (config.isIndexPage) {
            govCard.init();
        } else { // 非首页
            let channelNav = require('./js/channel-nav')
            if (config.categoryRender === 'client') { // 搜索页导航一步获取
                extendCate.init(config, res => {
                    if (res && res.code == 200) {
                        let $extendNav = $('#cate-index')
                        let extendNavTpl = res.data
                        if ($extendNav && $extendNav.length > 0) {
                            $extendNav.empty()
                            $extendNav.append(extendNavTpl)
                        }
                        channelNav.default.init()
                        cateNav.init(config);
                    } else {
                        console.log('请求导extend-nav失败', res)
                    }
                })
            } else { 
                channelNav.default.init()
            }
        }
        cateNav.init(config);
    }
}



// WEBPACK FOOTER //
// ./modules/cate-nav-index/index.js